import { Link, NavLink, useHistory } from 'react-router-dom';
import {
  FiUser,
  FiShoppingBag,
  FiLayers,
  FiDollarSign,
  FiLogOut,
  FiGift,
} from 'react-icons/fi';
import { BiWallet } from 'react-icons/bi';

import Button from '../Button';
import { useAuth } from '../../hooks/auth';
import { Container, MenuItem, Menu } from './styles';

const DesignerSideMenu = () => {
  const history = useHistory();
  const { signOut } = useAuth();

  function handleNewProjectButtonClick() {
    history.push('/designer/new-project');
  }

  return (
    <Container>
      <h2>Minha conta</h2>
      <Menu>
        <MenuItem>
          <FiLayers color="var(--accent)" size={20} />
          <NavLink to="/designer/projects" activeClassName="active">Meus projetos</NavLink>
        </MenuItem>
        <MenuItem>
          <FiDollarSign color="var(--accent)" size={19} />
          <NavLink to="/designer/remuneration" activeClassName="active">Remuneração</NavLink>
        </MenuItem>
        <MenuItem>
          <BiWallet color="var(--accent)" size={20} />
          <NavLink to="/designer/wallet" activeClassName="active">Minha carteira</NavLink>
        </MenuItem>
        <MenuItem>
          <FiUser color="var(--accent)" size={20} />
          <NavLink to="/designer/profile" activeClassName="active">Meus dados</NavLink>
        </MenuItem>
        <MenuItem>
          <FiShoppingBag color="var(--accent)" size={20} />
          <NavLink to="/designer/buys" activeClassName="active">Minhas compras</NavLink>
        </MenuItem>
        <MenuItem>
          <FiGift color="var(--accent)" size={20} />
          <NavLink to="/designer/indicate-a-friend" activeClassName="active">Indique um amigo</NavLink>
        </MenuItem>
        <MenuItem>
          <FiLogOut color="var(--accent)" size={20} />
          <Link to="/" onClick={signOut}>
            Sair do sistema
          </Link>
        </MenuItem>
      </Menu>
      <Button
        text="Novo Projeto"
        primary
        onClick={handleNewProjectButtonClick}
        withIcon="plus"
      />
    </Container>
  );
};

export default DesignerSideMenu;
